import {AuthRepository} from '@domain/model/Auth/AuthRepository';
import {FacebookToken} from '@domain/model/Auth/AuthLoginFaceBook';

export const LoginWithFaceBook = (repo: AuthRepository) => (params: FacebookToken) => repo.loginWithFaceBook(params);
